import Typography from "@common/components/Typography";
import { Box, IconButton } from "@mui/material";
import { PropsWithChildren } from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { WithGrow } from "@common/components/WithGrow";

export type DeckboardDrawerProps = {
  title: string;
  onClose: () => void;
  isCloseDisabled?: boolean;
  isContainerScrollable?: boolean;
};

const DeckboardDrawer = ({
  title,
  onClose,
  children,
  isCloseDisabled = false,
  isContainerScrollable = true,
}: PropsWithChildren<DeckboardDrawerProps>) => (
  <Box
    sx={{ paddingRight: 3, maxWidth: "100%", height: "100%" }}
    data-testid="deckboard-drawer"
  >
    <WithGrow
      direction="column"
      fixed={
        <>
          <Typography
            size="smaller"
            uppercase
            data-testid="deckboard-drawer-title"
          >
            {title}
          </Typography>
          <IconButton onClick={onClose} disabled={isCloseDisabled}>
            <ArrowBackIosNewRoundedIcon />
          </IconButton>
        </>
      }
      sx={(theme) => ({
        paddingTop: 2,
        paddingLeft: 2,
        borderRight: `1px solid ${theme.palette.grey[800]}`,
        height: "100%",
        maxWidth: "100%",
      })}
      fixedSx={(theme) => ({
        borderBottom: `1px solid ${theme.palette.grey[900]}`,
        color: theme.palette.grey[500],
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1,
      })}
      containerSx={{
        overflowY: isContainerScrollable ? "scroll" : undefined,
        paddingTop: 2,
        mx: 1,
        paddingRight: 2,
      }}
    >
      {children}
    </WithGrow>
  </Box>
);

export default DeckboardDrawer;
